import { Form, Input, Button, Card, Icon, Spin, Row, Col } from "antd";
import { Typography } from "antd";
import { UserService } from "../../services/user/UserService";
import React, { Component } from "react";
import { showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./User.css";
import "./CreateUser.css";
import { Translation } from "react-i18next";
import i18next from "i18next";

const { Text } = Typography;
class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.props.context.setCurrentComponent("changePassword");
    this.state = {
      isFetching: false,
      formLayout: "inline",
      changeForActivation: this.props.changeForActivation,
      sessionToken: this.props.sessionId,
      passwordLength: false,
      specialCharacter: false,
      oneNumber: false,
      fPasswordLength: true,
      fSpecialCharacter: true,
      fOneNumber: true,
    };
  }

  componentDidMount() {}

  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;
    let { updateUserAndSession } = this.props.context;
    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          this.userService = new UserService();
          values["userEmail"] = this.state.changeForActivation
            ? this.props.userEmail
            : this.props.context.user.userEmail;

          let data = await this.userService.changePassword(
            this.state.changeForActivation
              ? this.state.sessionToken
              : this.props.context.session_id,
            values
          );

          showSuccessToast(i18next.t("Password changed successfully"));
          if (this.state.changeForActivation) {
            updateUserAndSession(
              this.state.sessionToken,
              this.props.responseData
            );
          }
          this.setState({ loading: false, changeForActivation: false });

       if(this.props.responseData){
        if (
          this.props.responseData.userType == "SUPER" ||
          this.props.responseData.userType == "CARE"
        ) {
          history.push("/home/accounts");
        } else {
          if(this.props.responseData.userType == "LI"){
            history.push("/home/liveCalls");

          }else{
            history.push("/home/dashboard");
          }
        }
       }
       else{
          if (
            this.props.context.user.userType == "SUPER" ||
            this.props.context.user.userType == "CARE"
          ) {
            history.push("/home/accounts");
          } else {

  if(this.props.context.user.userType == "LI"){
            history.push("/home/liveCalls");

          }else{
            history.push("/home/dashboard");
          }          }
        }
          this.props.form.resetFields();
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (/\d/.test(form.getFieldValue("newPassword"))) {
      this.setState({ oneNumber: true });
    } else {
      this.setState({ oneNumber: false });
    }

    if (form.getFieldValue("newPassword").length >= 12) {
      this.setState({ passwordLength: true });
    } else {
      this.setState({ passwordLength: false });
    }
    if (
      !/^[A-Za-z0-9]+$/.test(form.getFieldValue("newPassword")) &&
      /^[a-zA-Z0-9|!£$€%&/"\\=?^*+@°'#„¨‥_()-]+$/.test(
        form.getFieldValue("newPassword")
      )
    ) {
      this.setState({ specialCharacter: true });
    } else {
      this.setState({ specialCharacter: false });
    }

    callback();
  };

  handleOnChange = (e) => {
    if (/\d/.test(e.target.value)) {
      this.setState({ fOneNumber: true });
    } else {
      this.setState({ fOneNumber: false });
    }

    if (e.target.value.length >= 12) {
      this.setState({ fPasswordLength: true });
    } else {
      this.setState({ fPasswordLength: false });
    }
    if (
      !/^[A-Za-z0-9]+$/.test(e.target.value) &&
      /^[a-zA-Z0-9|!£$€%&/=?^*+@°'#„¨‥_()-]+$/.test(e.target.value)
    ) {
      this.setState({ fSpecialCharacter: true });
    } else {
      this.setState({ fSpecialCharacter: false });
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    let { isFetching } = this.state;

    return (
      <Translation>
        {(t) => (
          <Page
            title={this.state.changeForActivation ? null : t("Change Password")}
            hasBackArrow={this.state.changeForActivation ? false : true}
          >
            {isFetching ? (
              <Spin></Spin>
            ) : this.state.changeForActivation ? (
              <Form>
                <Form.Item label={t("Current Password")}>
                  {getFieldDecorator("currentPassword", {
                    rules: [
                      {
                        required: true,
                        message: t("Please enter your current password"),
                      },
                    ],
                  })(<Input.Password maxLength={20} />)}
                </Form.Item>
                <Form.Item label={t("New Password")}>
                  {getFieldDecorator("newPassword", {
                    rules: [
                      {
                        required: true,
                        message: t("Please enter your new password"),
                      },
                    ],
                  })(
                    <Input.Password
                      onChange={this.handleOnChange}
                      maxLength={20}
                    />
                  )}
                  <Row>
                    <Col
                      style={{
                        display: this.state.fOneNumber ? "none" : "block",
                      }}
                    >
                      <Text
                        style={{
                          color: this.state.fOneNumber ? "#52c41a" : "red",
                        }}
                      >
                        {" "}
                        {t("Please enter at least one number")}{" "}
                      </Text>
                    </Col>
                    <Col
                      style={{
                        display: this.state.fPasswordLength ? "none" : "block",
                      }}
                    >
                      <Text
                        style={{
                          color: this.state.fPasswordLength ? "#52c41a" : "red",
                        }}
                      >
                        {" "}
                        {t("Please enter at least 12 characters")}{" "}
                      </Text>
                    </Col>
                    <Col
                      style={{
                        display: this.state.fSpecialCharacter
                          ? "none"
                          : "block",
                      }}
                    >
                      <Text
                        style={{
                          color: this.state.fSpecialCharacter
                            ? "#52c41a"
                            : "red",
                        }}
                      >
                        {" "}
                        {t("Please enter at least one special character")}
                      </Text>
                      <Col
                        style={{
                          color: this.state.fSpecialCharacter
                            ? "#52c41a"
                            : "red",
                        }}
                      >
                        (|!\"£$€%&/=?^'*+@°#„¨‥-_)
                      </Col>
                    </Col>
                  </Row>
                </Form.Item>

                <Form.Item label={t("Confirm Password")}>
                  {getFieldDecorator("confirmPassword", {
                    rules: [
                      {
                        required: true,
                        message: t("Please confirm your new password"),
                      },
                    ],
                  })(<Input.Password maxLength={20} />)}
                </Form.Item>

                <Form.Item
                  wrapperCol={{
                    xs: { span: 24, offset: 0 },
                    sm: { span: 16, offset: 8 },
                  }}
                >
                  <Button
                    className="button-submit"
                    type="primary"
                    onClick={this.handleConfirm}
                    size={"small"}
                    loading={this.state.loading}
                  >
                    {i18next.t("Submit")}
                  </Button>
                </Form.Item>
              </Form>
            ) : (
              <Card
                style={{
                  marginTop: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                }}
                bordered={false}
              >
                <Form className="form-style" {...formItemLayout}>
                  <Form.Item label={t("Current Password")} {...formItemLayout}>
                    {getFieldDecorator("currentPassword", {
                      rules: [
                        {
                          required: true,
                          message: t("Please enter your current password"),
                        },
                      ],
                    })(<Input.Password maxLength={20} />)}
                  </Form.Item>
                  <Form.Item label={t("New Password")} {...formItemLayout}>
                    {getFieldDecorator("newPassword", {
                      rules: [
                        {
                          required: true,
                          message: t("Please enter your new password"),
                        },
                        {
                          validator: this.validateToNextPassword,
                        },
                      ],
                    })(<Input.Password maxLength={20} />)}
                    <div style={{ marginLeft: "-2px" }}>
                      <Icon
                        type="check-circle"
                        theme="twoTone"
                        twoToneColor={
                          this.state.oneNumber ? "#52c41a" : "#c7c9cc"
                        }
                      />
                      <span> {t("At least one number")}</span>

                      <Icon
                        type="check-circle"
                        theme="twoTone"
                        twoToneColor={
                          this.state.passwordLength ? "#52c41a" : "#c7c9cc"
                        }
                        style={
                          this.props.context.curr_dir === "ltr" &&
                          this.props.context.curr_lang === "en"
                            ? { marginLeft: "12px" }
                            : { marginRight: "12px" }
                        }
                      />
                      <span> {t("At least 12 characters")}</span>
                      <Icon
                        type="check-circle"
                        theme="twoTone"
                        twoToneColor={
                          this.state.specialCharacter ? "#52c41a" : "#c7c9cc"
                        }
                        style={
                          this.props.context.curr_dir === "ltr" &&
                          this.props.context.curr_lang === "en"
                            ? { marginLeft: "12px" }
                            : { marginRight: "12px" }
                        }
                      />
                      <span>
                        {" "}
                        {t("At least one special character")}
                        (|!\"£$€%&/=?^'*+@°#„¨‥-_)
                      </span>
                    </div>
                  </Form.Item>

                  <Form.Item label={t("Confirm Password")} {...formItemLayout}>
                    {getFieldDecorator("confirmPassword", {
                      rules: [
                        {
                          required: true,
                          message: t("Please confirm your new password"),
                        },
                      ],
                    })(<Input.Password maxLength={20} />)}
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{
                      xs: { span: 24, offset: 0 },
                      sm: { span: 16, offset: 8 },
                    }}
                  >
                    <Button
                      className="button-submit"
                      type="primary"
                      onClick={this.handleConfirm}
                      size={"small"}
                      loading={this.state.loading}
                      disabled={
                        this.state.oneNumber &&
                        this.state.passwordLength &&
                        this.state.specialCharacter
                          ? false
                          : true
                      }
                    >
                      {t("Submit")}
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(ChangePassword))
);
